import React from 'react';
import { XCircle, AlertTriangle, TrendingDown, Users } from 'lucide-react';
export function ProblemSection() {
  const consequences = [{
    icon: <TrendingDown className="w-6 h-6 text-red-500" aria-hidden="true" data-id="element-189" />,
    title: 'Perdés margen de ganancia',
    desc: 'Comprás materiales equivocados o calculás mal las cantidades.'
  }, {
    icon: <XCircle className="w-6 h-6 text-red-500" aria-hidden="true" data-id="element-190" />,
    title: 'Trabajos arruinados',
    desc: 'Burbujas, desniveles o curado incorrecto que tenés que arreglar de tu bolsillo.'
  }, {
    icon: <Users className="w-6 h-6 text-red-500" aria-hidden="true" data-id="element-191" />,
    title: 'Clientes que no vuelven',
    desc: 'Un piso mal terminado arruina tu reputación antes de empezar.'
  }, {
    icon: <AlertTriangle className="w-6 h-6 text-red-500" aria-hidden="true" data-id="element-192" />,
    title: 'Miedo a cotizar',
    desc: 'Cobrás barato por inseguridad y terminás trabajando gratis.'
  }];
  return <section className="py-16 px-4 bg-[#0a0a0a]" aria-label="Errores comunes al aplicar epoxi" data-id="element-193">
      <div className="max-w-4xl mx-auto" data-id="element-194">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-white uppercase tracking-tight flex items-center justify-center gap-3" data-id="element-195">
          <AlertTriangle className="w-8 h-8 text-amber-500" aria-hidden="true" data-id="element-196" />
          El error que te puede costar caro
        </h2>

        <ul className="grid md:grid-cols-2 gap-6 mb-12 list-none p-0" data-id="element-197">
          {consequences.map((item, index) => <li key={index} className="bg-[#141414] p-6 rounded-xl border border-red-900/20 flex items-start gap-4" data-id="element-198">
              <div className="bg-red-500/10 p-2 rounded-lg flex-shrink-0 mt-1" data-id="element-199">
                {item.icon}
              </div>
              <div data-id="element-200">
                <h3 className="text-xl font-bold text-gray-200 mb-2" data-id="element-201">
                  {item.title}
                </h3>
                <p className="text-gray-400" data-id="element-202">{item.desc}</p>
              </div>
            </li>)}
        </ul>

        <div className="text-center bg-amber-900/10 border-l-4 border-amber-500 p-6 rounded-r-xl max-w-3xl mx-auto" data-id="element-203">
          <p className="text-xl md:text-2xl font-bold text-amber-400" data-id="element-204">
            La diferencia entre ganar plata y perderla está en saber cómo
            hacerlo bien desde el primer trabajo.
          </p>
        </div>
      </div>
    </section>;
}